import autoBind from "auto-bind";
import EventBus from "src/core/common/eventBus";
import DataSource from "src/core/data-sources/dataSource";
import * as PaymentsApi from "src/core/api/payments";
import {PaymentSource} from "src/core/payments/models/paymentSource";

class MonerisPaymentSourcesDataSource extends DataSource {
  constructor() {
    super();
    autoBind(this);
  }

  doGet() {
    return PaymentsApi.monerisPaymentSources().then(({data}) =>
      data.map((obj) => new PaymentSource(obj, "moneris"))
    );
  }

  getEventBus() {
    return eventBus;
  }
}
const eventBus = new EventBus();

export default MonerisPaymentSourcesDataSource;
